export type CollectionHistoryState = {
  url: string;
  navParent: string | null;
};

type PopStateHandler = (state: CollectionHistoryState) => void;

let popStateHandler: PopStateHandler | null = null;
let historyBound = false;

export const pushCollectionState = (url: string, navParent: string | null) => {
  window.history.pushState({ url, navParent } satisfies CollectionHistoryState, "", url);
};

export const initCollectionHistory = (handler: PopStateHandler) => {
  popStateHandler = handler;
  if (historyBound) return;
  historyBound = true;

  window.addEventListener("popstate", (event) => {
    const state = event.state as CollectionHistoryState | null;
    if (!state?.url || !state.url.includes("/collections/")) return;
    popStateHandler?.(state);
  });
};
